import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import AnalyticsUtils from '../../analytics/utils'
import {getCurrentUser} from '../services'
import {setIsLoading, setUser} from '../modules/slice'
import {useHistory} from 'react-router'
import {toggle} from 'opticks/lib/optimizely'
import {updateProfilePictureUrl} from '../modules/thunks'

import {COGNITO_LOGIN_CALLBACK_ROUTE} from '../constants'

export const FetchUser = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const updateUser = async () => {
      dispatch(setIsLoading(true))

      const user = await getCurrentUser()
      AnalyticsUtils.resetAnalytics(user?.attributes?.sub)
      if (user?.id) {
        dispatch(setUser({user, isAuthenticated: true, isPrivileged: true}))

        if (user?.attributes?.picture) {
          dispatch(updateProfilePictureUrl(user.attributes.picture))
        }
      }

      dispatch(setIsLoading(false))
    }

    // TODO (@gabrielmanara) [2022-07-15]: We'll keep this until we launch the Cognito as we don't have the ab toggle in the url callback
    if (history?.location?.pathname === COGNITO_LOGIN_CALLBACK_ROUTE) {
      void updateUser()
    }

    toggle(
      'f54ef0b3-cognito-auth',
      () => null,
      () => {
        void updateUser()
      }
    )
  }, [dispatch, history])

  return null
}
